import {Accordion, AccordionSummary, AccordionProps} from "@mui/material"
import {ExpandMore} from "@mui/icons-material"
import React from "react"
import {AvantColors} from "../../styles/AvantColors"
import {H2Text} from "../../styles/AvantTypography"

interface AvantExpansionPanelProps extends AccordionProps {
    title: string
    /** A score to be placed in the Accordion Summary
     *  Used in PLACE individual reports */
    score?: string
}

export const AvantExpansionPanel = (props: AvantExpansionPanelProps) => {
    const {title, score, children, ...rest} = props

    const [inputValue, setInputValue] = React.useState(false)

    const handleAccordionChange = () => {
        setInputValue(!inputValue)
    }

    return (
        <Accordion sx={{
            borderRadius: "6px",
            backgroundColor: "#FFFFFF",
            boxShadow: "none",
            border: `1px solid ${AvantColors.REPORT_BOX_BORDER}`,
            marginBottom: "10px"
        }}
                   defaultExpanded={true}
                   onChange={handleAccordionChange} {...rest}>
            <AccordionSummary sx={{
                borderRadius: "6px",
                backgroundColor: AvantColors.REPORT_BACKGROUND_GRAY_DARK,
                display: "flex",
                justifyContent: "space-between",
            }} expandIcon={<ExpandMore/>}>
                <H2Text>
                    {title}
                </H2Text>
                {
                    !inputValue &&
                    <H2Text>
                        {score}
                    </H2Text>
                }
            </AccordionSummary>
            {children}
        </Accordion>
    )
}